<template>
    <div class="aaaaa" style="height: 800px;padding-bottom: 50px;">
        <div class="page-header md-2018121001-xxw">
            <div class="clearfix container">
                <div class="logo-box pull-left">
                    <a class="logo examlogo" href="javascript:;" style="left: 0;top:16px;
                                      font-weight: bold;font-size: 16px;color: #ffffff">职业技能等级认定考试系统</a>
                </div>
                <ul class="nav-xxw pull-left">
                    <li class=""><a class="shouye" href="/">首页</a></li>
                    <li class="active"><a class="examZxks">在线考试</a></li>
                </ul>
                <!-- <div class="pull-right">
                    <a href="/" class="form-btn form-btn-blue from-save" id="out_login"
                        style="background-color: #4fc7ff;border-color: #4fc7ff;color: #ffffff;">退出</a>
                </div> -->
            </div>
        </div>

        <div class="page-body">
            <div class="container md-2018121102-xxw">
                <p class="md-hd bg-fff color-28b2f7 padding-40px">考试列表</p>
                <div class="md-bd bg-fff">
                    <div class="scrach-box clearfix">
                        <div class="form-group clearfix pull-left">
                            <input v-model="val" class="pull-left" type="text" placeholder="输入考试名称">

                            <span @click="select" id="search_btn" class="pull-left"> <i
                                    class="layui-icon layui-icon-search" style="font-size: 27px"></i> </span>
                        </div>
                    </div>


                    <el-table :data="examlist" style="width: 100%;margin-top:25px">
                        <!-- 序号 -->
                        <el-table-column align="center" label="序号" width="50" type="index">
                        </el-table-column>
                        <!-- 考试名称 -->
                        <el-table-column label="考试名称" width="180" prop="testName" align="center">
                        </el-table-column>
                        <!-- 考试开始时间  -->
                        <el-table-column label="考试开始时间" width="160" prop="beginTime" align="center">
                        </el-table-column>
                        <!-- 考试截止时间  -->
                        <el-table-column label="考试截止时间" width="160" prop="endTime" align="center">
                        </el-table-column>

                        <!-- 状态 -->
                        <el-table-column label="状态" width="100" align="center">
                            <template slot-scope="scope">
                                <!-- 未开始 -->
                                <span v-if="scope.row.testState == 0 && longTime < scope.row.beginLongTime"
                                    class="ks-typex ks-typex2" style="background-color: #989898">未开始</span>
                                <!-- 进行中 -->
                                <span
                                    v-if="scope.row.testState == 0 && longTime > scope.row.beginLongTime && longTime < scope.row.endLongTime"
                                    class="ks-typex ks-typex2">进行中</span>

                                <!-- 已结束 -->
                                <span v-if="longTime > scope.row.endLongTime || scope.row.testState == 2" class="ks-typex ks-typex2"
                                    style="background-color: #989898">已结束</span>

                            </template>
                        </el-table-column>

                        <!-- 考试时长(分钟)  -->
                        <el-table-column label="考试时长(分钟)" width="90" prop="testSetTime" align="center">
                        </el-table-column>

                        <!-- 总题量  -->
                        <el-table-column label="总题量" width="80" prop="testQueNum" align="center">
                        </el-table-column>

                        <!-- 理论成绩-->
                        <el-table-column label="理论成绩" width="80" prop="workTypeLevelStateDesc" align="center">
                            <template slot-scope="scope">
                                <span
                                    v-if="scope.row.testState == 2"
                                    class="layui-badge layui-bg-gray">未批阅</span>

                                <!-- <span
                                    v-if="scope.row.testState == 1 && scope.row.achievementState ==2 && scope.row.resultState == 1"
                                    class="layui-badge" style="background-color: red;">未通过</span> -->

                                <!-- <span
                                    v-if="scope.row.testState == 1 && scope.row.achievementState ==2 && scope.row.resultState == 2"
                                    class="layui-badge" style="background-color: green;">通过</span> -->

                                <!-- 
                                <span v-if="scope.row.testState == 1 && scope.row.achievementState !=2"
                                    class="layui-badge layui-bg-gray">未公布</span> -->

                                <span v-if="scope.row.testState === 0" class="layui-badge layui-bg-gray">未考试</span>

                            </template>
                        </el-table-column>


                        <!-- 实操成绩  -->
                        <el-table-column label="实操成绩" width="80" prop="workTypeLevelStateDesc" align="center">
                            <template slot-scope="scope">
                                <span
                                    v-if="scope.row.testState == 2"
                                    class="layui-badge layui-bg-gray">未批阅</span>

                                <!-- <span
                                    v-if="scope.row.testState == 1 && scope.row.achievementState ==2 && scope.row.resultStatePractice == 1"
                                    class="layui-badge" style="background-color: red;">未通过</span>

                                <span
                                    v-if="scope.row.testState == 1 && scope.row.achievementState ==2 && scope.row.resultStatePractice == 2"
                                    class="layui-badge" style="background-color: green;">通过</span>


                                <span v-if="scope.row.testState == 1 && scope.row.achievementState !=2"
                                    class="layui-badge layui-bg-gray">未公布</span> -->

                                <span v-if="scope.row.testState === 0" class="layui-badge layui-bg-gray">未考试</span>
                            </template>
                        </el-table-column>



                        <el-table-column label="操作" width="100" align="center">
                            <template slot-scope="scope">

                                <a v-if="scope.row.testState != 2&&longTime < scope.row.beginLongTime" href="javascript:;"
                                    class="examNotBegin"><span class="ks-btn ks-btn1"
                                        style="background-color: #989898">未开始</span></a>

                                <span v-if="scope.row.testState != 2&&longTime > scope.row.beginLongTime && longTime < scope.row.endLongTime"
                                    @click="ImmediatelyTheTest(scope.row)" class="ks-btn ks-btn1">立即考试</span>

                                <span v-if="longTime > scope.row.endLongTime || scope.row.testState == 2" class="ks-btn ks-btn1"
                                    style="background-color: #989898">考试结束</span>
                            </template>
                        </el-table-column>
                    </el-table>

                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[5,10,15]" :page-size="pagesize"
                        layout="total, sizes, prev, pager, next, jumper" :total="total" style="margin-top: 30px;">
                    </el-pagination>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: 'app',
        components: {

        },
        data() {
            return {
                val: '',
                examlist: [],
                total: 0,   //一共多少条
                pagesize: 5,  //一页几条
                currentPage: 1,//当前页
                longTime: 0
            }
        },
        created() {
            //加载考试列表
            this.loadExamList(this.currentPage, this.pagesize, '');

            //获取服务器时间
            this.getSysTime();
        },
        mounted() {

             //禁止鼠标右键！
             document.oncontextmenu = function(e) {
                return false;
            };

        },
        beforeDestroy() {

        },
        methods: {
            select() {
                console.log(this.val);
                this.currentPage = 1;
                this.loadExamList(1, this.pagesize, this.val);
            },
            ImmediatelyTheTest(row) {
                if (row.testState == 2) {
                    this.$message({
                        showClose: true,
                        message: '当前考试被禁用！',
                        offset: 300
                    });
                } else {
                    this.$router.push({ path: '/exam', query: { testId: row.id, paperId: row.paperId } });
                }
            },
            //切换每页多少条 触发
            handleSizeChange(val) {
                console.log(`每页dusoaho条`);
                this.pagesize = val;
                this.loadExamList(this.currentPage, this.pagesize, this.val);
            },
            //第几页切换的时 触发
            handleCurrentChange(val) {
                this.currentPage = val;
                this.loadExamList(this.currentPage, this.pagesize, this.val);
            },
            getSysTime() {
                return new Promise((resolve, reject) => {
                    this.$axios.post(this.serverUrl + '/serverTime/getServerTime').then(resp => {
                        this.longTime = resp.data.serverTime;
                        resolve();
                    }).catch(err => {
                    })
                });
            },
            loadExamList(page, limit, examName) {
                let parames = new URLSearchParams();
                parames.append('userId', this.$storage.get("declareUser").id);
                parames.append('limit', limit);
                parames.append('page', page);
                parames.append('testType', 3);
                parames.append('testName', examName);

                let ArrayList = [];
                this.$axios.post(this.serverUrl + '/ex/getExercisesList', parames).then(resp => {

                        //能进来此接口就一定有考试信息 直接循环获取
                        this.total = resp.data.recordsFiltered;
                        resp.data.data.forEach(element => {
                            let exam = {
                                id: 0,
                                paperId: 0,
                                testName: '',//考试名称
                                beginTime: '',//考试开始时间
                                endTime: '',//考试结束时间
                                beginLongTime: 0,//考试开始时间时间戳
                                endLongTime: 0,//考试结束时间时间戳
                                testSetTime: 0,//测试规定用时，毫秒
                                testQueNum: 0,//总题量
                                testState: 0,//测试状态 1进行中 2 已结束
                                resultState: 0,////考试结果标识：0：未批阅 1不通过 2通过
                                resultStatePractice: 0,////实操考试结果标识：0：未批阅 1不通过 2通过
                                achievementState: 0//成绩公布状态 默认1不公布 2公布
                            }


                            exam.id = element.id;
                            exam.paperId = element.paperId;
                            exam.testName = element.testName; //标题
                            exam.beginTime = element.beginTime; //考试开始时间
                            exam.endTime = element.endTime;
                            exam.beginLongTime = new Date(element.beginTime).getTime();
                            exam.endLongTime = new Date(element.endTime).getTime();
                            exam.testSetTime = (parseInt(element.testSetTime) / 60000).toFixed(0);
                            exam.testQueNum = element.testQueNum;
                            exam.testState = element.testState;
                            exam.resultState = element.resultState;
                            exam.resultStatePractice = element.resultStatePractice;

                            exam.achievementState = element.achievementState;//成绩公布状态 默认1不公布 2公布


                            ArrayList.push(exam);
                        });
                        this.examlist = ArrayList;

                }).catch(err => {

                })
            }
        }
    }
</script>

<style scoped>
    .md-2018121001-xxw .nav-xxw li a {
        display: block;
        color: inherit;
    }

    .md-2018121001-xxw .nav-xxw .active {
        color: #ffcc33;
        font-weight: bold;
    }

    .form-btn {
        display: inline-block;
        padding: 5px 24px 6px;
        margin-bottom: 0;
        font-size: 14px;
        font-weight: normal;
        line-height: 1.42857143;
        text-align: center;
        white-space: nowrap;
        vertical-align: middle;
        -ms-touch-action: manipulation;
        touch-action: manipulation;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        background-image: none;
        border: 1px solid transparent;
        border-radius: 4px;
        /* height: 32px; */
    }

    .ks-btn {
        display: inline-block;
        line-height: 26px;
        background: #29b2f7;
        color: #fff;
        padding: 2px 8px;
        border-radius: 4px;
        cursor: pointer;
    }

    .layui-bg-gray {
        background-color: #eee !important;
        color: #666 !important;
    }

    .layui-badge {
        height: 18px;
        line-height: 18px;
        position: relative;
        display: inline-block;
        padding: 0 6px;
        font-size: 12px;
        text-align: center;
        color: #fff;
        border-radius: 2px;
    }

    .ks-typex {
        display: inline-block;
        line-height: 26px;
        background: #ec7064;
        color: #fff;
        padding: 0 16px;
        border-radius: 15px;
    }

    .md-2018121102-xxw .form-group span[data-v-6b497b7c] {
        width: 48px;
        height: 50px;
        font-size: 24px;
        background: #2196f3;
        text-align: center;
        line-height: 46px;
        color: #fff;
        cursor: pointer;
    }

    .layui-icon-search:before {
        content: "\e615";
    }

    .layui-icon {
        font-family: layui-icon !important;
        font-size: 16px;
        font-style: normal;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    .md-2018121102-xxw .form-group span {
        width: 48px;
        height: 50px;
        font-size: 24px;
        background: #bdc3c7;
        text-align: center;
        line-height: 46px;
        color: #fff;
        cursor: pointer;
    }

    .md-2018121102-xxw .form-group input {
        width: 750px;
        height: 100%;
        padding-left: 10px;
        background: #fdfdfd;
        border: none;
    }

    .md-2018121102-xxw .form-group {
        width: 800px;
        height: 48px;
        border-radius: 4px;
        border: 1px solid #bdc3c7;
        overflow: hidden;
        display: flex;
    }

    .md-2018121102-xxw>.md-bd {
        padding: 30px 40px;
    }

    .color-28b2f7 {
        color: #28b2f7;
    }

    .bg-fff {
        background: #fff;
    }

    .padding-40px {
        padding: 0 40px;
    }

    .md-2018121102-xxw .md-hd {
        line-height: 50px;
        margin: 28px 0;
        border-radius: 8px;
        font-size: 16px;
        font-weight: bold;
    }

    .aaaaa {
        background: #f3f2f2;
        line-height: 24px;
        font: 14px Helvetica Neue, Helvetica, PingFang SC, Tahoma, Arial, sans-serif;
    }

    .md-2018121001-xxw .nav-xxw li {
        float: left;
        margin-right: 35px;
    }

    .md-2018121001-xxw .nav-xxw .active {
        color: #ffcc33;
        font-weight: bold;
    }

    .md-2018121001-xxw .nav-xxw {
        color: #ffffff;
        margin-left: 68px;
        font-size: 16px;
    }

    a {
        color: #333;
        text-decoration: none;
    }

    .md-2018121001-xxw {
        background: #049be2;
        height: 70px;
        line-height: 68px;
    }

    .container {
        clear: both;
        margin: 0 auto;
        text-align: left;
        width: 1200px;
    }

    .pull-left {
        float: left;
    }

    .pull-right {
        float: right;
    }
</style>


// WEBPACK FOOTER //
// src/components/exam/examPrepositionPage.vue